import React, { useState, useEffect } from 'react'
import Dropdown from '../../Components/utils/ReuseDropdown';
import axios from 'axios';
import { showToast } from "../../Components/utils/ShowToast";
import { FaEnvelope, FaLock, FaLockOpen } from 'react-icons/fa';
import { MdChat } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import AdminSendEmailPopup from '../../Components/admin/AdminSendEmailPopup';
import Loader from '../../Components/utils/Loader';
import ConfirmDialog from '../../Components/utils/ReuseConfirmDialog';

function AdminBuyers() {
    const [buyers, setBuyers] = useState([]);
    const [filterType, setFilterType] = useState('All');
    const [isUpdated, setIsUpdated] = useState(false);
    const [isLoading, setIsLoading] = useState(false); // State for loading
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false); // State for confirmation dialog
    const [selectedUserId, setSelectedUserId] = useState(null); // State for selected user ID
    const [selectedUserBlockStatus, setSelectedUserBlockStatus] = useState(false); // State for selected user block status
    const navigate = useNavigate();
    const [showEmailPopup, setShowEmailPopup] = useState(false);
    const [selectedBuyerEmail, setSelectedBuyerEmail] = useState(null);

    useEffect(() => {
        const fetchBuyers = async () => {
            setIsLoading(true); // Start loading
            const token = localStorage.getItem('adminToken');
            try {
                const response = await axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/admins/buyers/all/`, {
                    headers: { Authorization: `Bearer ${token}` },
                    params: { filterType }
                });
                if (response.data.success) {
                    // Sort buyers by updatedAt (most recent first)
                    const sortedBuyers = response.data.allUsers.sort(
                        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                    );
                    setBuyers(sortedBuyers);
                }
            } catch (e) {
                showToast(e.response?.data?.error || 'Something went wrong!', 'error');
            } finally {
                setIsLoading(false); // Stop loading regardless of success or failure
            }
        };

        fetchBuyers();
    }, [filterType, isUpdated]);

    const handleSendEmail = (user) => {
        setSelectedBuyerEmail(user.email);
        setShowEmailPopup(true);
    };

    const handleBlockUser = async (userId, isBlocked) => {
        try {
            const token = localStorage.getItem('adminToken');
            const response = await axios.put(
                `${process.env.REACT_APP_Backend_Host_Name}/api/v1/auth/block/`,
                { userId, isBlocked },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data.success) {
                setIsUpdated(prev => !prev)
                showToast(isBlocked ? "User has been UnBlocked!" : 'User has been blocked!', 'success');
            }
        } catch (e) {
            showToast(e.response?.data?.error || 'Something went wrong!', 'error');
        }
    };

    const handleConfirmBlockUser = (userId, isBlocked) => {
        setSelectedUserId(userId);
        setSelectedUserBlockStatus(isBlocked);
        setConfirmDialogOpen(true);
    };

    const onConfirmAction = () => {
        handleBlockUser(selectedUserId, selectedUserBlockStatus);
        setConfirmDialogOpen(false);
    };

    const onCancelAction = () => {
        setConfirmDialogOpen(false);
    };

    const buyerElems = buyers.length > 0 ? buyers.map((item, index) => (
        <div key={index}>
            <div className="requestRow row">
                <div className="titleField field">
                    <p className="title">{item.email}</p>
                </div>
                <p className="usernameField field">{item.username}</p>
                <p className="statusField field">{item.userStatus}</p>
                <p className="joinField field">{new Date(item?.createdAt).toLocaleDateString()}</p>
                <div className="actionsField field">
                    <MdChat className="icon" onClick={() => navigate(`/chwi-admin/chats/?p=${item?._id}`)} />
                    <FaEnvelope className="icon"
                        onClick={() => handleSendEmail(item)}
                    />
                    {item.userStatus === 'Blocked' ?
                        <FaLockOpen style={{ color: "var(--success)" }} className="icon" onClick={() => handleConfirmBlockUser(item._id, true)} />
                        :
                        <FaLock style={{ color: "var(--danger)" }} className="icon" onClick={() => handleConfirmBlockUser(item._id, false)} />
                    }
                </div>
            </div>
            {buyers.length > 1 && buyers.length - 1 !== index && <div className="horizontalLine"></div>}
        </div >
    ))
        : <div className="row">Nothing to show here...</div>;

    return (
        <div className='adminBuyersDiv'>
            <div className="adminBuyersContent">
                <div className="tableDiv">
                    <div className="tableContent">
                        <div className="upper">
                            <h2 className="secondaryHeading">
                                <span>{filterType} </span>Buyers
                                <span className="totalRows">- {(buyers.length < 10 && '0') + buyers.length}</span>
                            </h2>
                            <div className="upperRight">
                                <Dropdown options={["All", "Active", "Blocked"]} onSelect={setFilterType} selected={filterType} />
                            </div>
                        </div>
                        <div className="header">
                            <p className="title">Email</p>
                            <p>Username</p>
                            <p>Status</p>
                            <p>Member Since</p>
                            <p>Actions</p>
                        </div>
                        {isLoading ? (
                            <Loader type="simpleMini" /> // Show loader while loading
                        ) : (
                            <div className="rows">{buyerElems}</div>
                        )}
                    </div>
                </div>

                <AdminSendEmailPopup
                    show={showEmailPopup}
                    onClose={() => setShowEmailPopup(false)}
                    defaultRecipients={selectedBuyerEmail ? [selectedBuyerEmail] : []}
                    showButtons={true}
                />

                {/* Confirmation Dialog */}
                <ConfirmDialog
                    open={confirmDialogOpen}
                    title={selectedUserBlockStatus ? 'Unblock User' : 'Block User'}
                    message={
                        selectedUserBlockStatus
                            ? 'Are you sure you want to unblock this user?'
                            : 'Are you sure you want to block this user?'
                    }
                    onConfirm={onConfirmAction}
                    onCancel={onCancelAction}
                    isLoading={isLoading}
                />
            </div>
        </div>
    )
}

export default AdminBuyers